import { render, staticRenderFns } from "./GridKioskDevices.vue?vue&type=template&id=81d70a0e&"
import script from "./GridKioskDevices.vue?vue&type=script&lang=js&"
export * from "./GridKioskDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81d70a0e')) {
      api.createRecord('81d70a0e', component.options)
    } else {
      api.reload('81d70a0e', component.options)
    }
    module.hot.accept("./GridKioskDevices.vue?vue&type=template&id=81d70a0e&", function () {
      api.rerender('81d70a0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/kiosk-devices/grid/GridKioskDevices.vue"
export default component.exports